<script setup lang="ts">
import { AppBackground, ProjectHeaderImage } from '@haskoning/vue-component-library'
</script>
<template>
  <div class="fill-height test">
    <ProjectHeaderImage :lazy-src="'/header_lazy.jpg'" :src="'/header.jpeg'" />
    <AppBackground>
      <v-container class="d-flex justify-center align-center" style="min-height: 300px">
        <v-card-text class="text-center">
          <v-icon color="primary" size="48" class="mb-3">mdi-timer-sand</v-icon>
          <div class="coming-soon-title">Coming Soon</div>
          <div class="coming-soon-message">This will become available in the next version</div>
        </v-card-text>
      </v-container>
    </AppBackground>
  </div>
</template>

<style scoped>
.coming-soon-card {
  padding: 24px 20px;
  border-radius: 12px;
}

.coming-soon-title {
  font-family: 'Roboto', Arial, Helvetica, sans-serif;
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #009eab;
}

.coming-soon-message {
  font-family: 'Roboto', Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #444;
}
</style>
